import { CxsBasket } from '../model';

export const removeCouponCode = (basket: CxsBasket, code: string): CxsBasket => {
    const { couponCodes } = basket;
    const index = couponCodes.findIndex(existingCode => existingCode.toLocaleLowerCase() === code.toLocaleLowerCase());
    if (index === -1) {
        return basket;
    }
    const newCodes = [...couponCodes];
    newCodes.splice(index, 1);
    return {
        ...basket,
        couponCodes: newCodes
    };
};
